import { useQuery } from '@tanstack/react-query'

import { wholesaleMarketClient } from '@/api'

export const useWholesaleMarketDatasetNames = () => {
  const { data } = useQuery({
    queryKey: [...wholesaleMarketClient.QUERY_KEY, { lockedOnly: false }],
    queryFn: () => wholesaleMarketClient.getAll()
  })

  return data?.map(x => x.name || '').filter(Boolean) || []
}
